import { FORGET_USER, FORGET_USER_SUCCESSFUL, FORGET_PASSWORD_API_FAILED, RESET_PASSWORD, RESET_FORGET_USER, IS_LOADING } from "./actionTypes";

const initialState = {
  user: null,
  forgetError: null,
  message: null,
  loading: false,
  OTPTime: null,
};

const forgetpwd = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_USER:
      return {
        ...state,
        user: null,
        loading: true,
        forgetError: null,
      };
    case FORGET_USER_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload.email,
        message: action.payload.msg,
        OTPTime: Date.now(),
        forgetError: null,
      };
    case FORGET_PASSWORD_API_FAILED:
      return {
        ...state,
        loading: false,
        forgetError: action.payload,
        message: null,
        // OTPTime: null,
        // user: null,
      };
    case RESET_PASSWORD:
      return {
        ...state,
      };
    case RESET_FORGET_USER:
      return {
        user: null,
        loading: false,
        forgetError: null,
        message: null,
        OTPTime: null,
      };

    case IS_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};

export default forgetpwd;
